import { Search, X } from "lucide-react";
import { Input } from "../../../components/ui/input";
import { Button } from "../../../components/ui/button";
import { cn } from "../../../lib/utils";

interface SearchBarProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
}

export function SearchBar({
  value,
  onChange,
  placeholder = "Tìm bệnh nhân, mã hẹn, bác sĩ...",
  className,
}: SearchBarProps) {
  return (
    <div className={cn("relative flex items-center", className)}>
      <Search className="absolute left-3 h-4 w-4 text-muted-foreground pointer-events-none" />
      <Input
        type="search"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="pl-9 pr-9 min-w-[200px] lg:min-w-[300px]"
        data-testid="input-search"
      />
      {value && (
        <Button
          type="button"
          variant="ghost"
          size="icon"
          className="absolute right-0 h-full px-3"
          onClick={() => onChange("")}
          data-testid="button-search-clear"
        >
          <X className="h-4 w-4" />
          <span className="sr-only">Xóa tìm kiếm</span>
        </Button>
      )}
    </div>
  );
}
